import { Grid, Box, Paper, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Copyright } from "../components/Copyright";
import {
    ConsentActionButtons,
    ConsentDocumentBody,
    centeredPaperStyle,
} from "../components/ConsentDocumentBody";
import * as AuthenticationUtil from "../util/AuthenticationUtil";
import * as Endpoints from "../util/Endpoints";
import * as ApiUtil from "../util/ApiUtil";

import { useAlert } from "../util/useAlert";
import { usePageLoader } from "../util/usePageLoader";
import logo from "../images/logo-hpv-vaccination.png";

export const ConsentPage = () => {

    const [consentText, setConsentText] = useState("");

    const [alert, showAlert] = useAlert();
    const [loader, showLoader, hideLoader] = usePageLoader();

    const [accepted, setAccepted] = useState();

    useEffect(() => {
        const getConsentText = async () => {
            try {
                showLoader();
                const responseData = await ApiUtil.callBackend(Endpoints.consentText, "GET");
                console.log(responseData);

                if (!responseData.status) {
                    showAlert(responseData.message, "error");
                }
                setConsentText(responseData.data.consent);
            } catch (error) {
                console.log(error);
                showAlert(error.message, "error");
            } finally {
                hideLoader();
            }
        }
        getConsentText();
    }, []);

    if (AuthenticationUtil.isAuthenticated()) {
        return <Redirect to="/questionnaire" />;
    }

    const handleClickDecline = () => {
        showAlert("Du måste acceptera för att fortsätta.", "error");
    };

    if (accepted) {
        return <Redirect to="/login" />;
    }

    const handleClickAccept = () => {
        setAccepted(true);
    };

    return (
        <div>
            <Box m={1}>
                <Grid container justifyContent="center" alignItems="center" spacing={1}>
                    <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
                        <img src={logo} height={90} alt="" />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        style={{ display: "flex", justifyContent: "center", width: "100%" }}
                    >
                        <Paper style={centeredPaperStyle}>
                            <Box p={2}>
                                <Typography
                                    variant="subtitle1"
                                    component="h1"
                                    align="center"
                                    style={{ fontWeight: 600 }}
                                >
                                    Samtycke
                                </Typography>
                                <Box mt={2}>
                                    <ConsentDocumentBody html={consentText} />
                                </Box>
                                <ConsentActionButtons
                                    onAccept={handleClickAccept}
                                    onDecline={handleClickDecline}
                                />
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
            <Copyright />
            {loader}
            {alert}
        </div>
    );
}
